ulekareApp.factory('AskFormStorage', function(C){
	if (C.isOrder === true) {
		var storageName = 'OrderFormStorage';
	} else {
		var storageName = 'QuestionFormStorage';
		var pathnameArr = window.location.pathname.split('/');

		if (pathnameArr.length === 3) {
			storageName += pathnameArr.pop();
		}
	}
	var ds = new DataStorage(storageName, 'sessionStorage');
	ds.getId = function() {
		return this.get('id');
	};
	ds.hasId = function() {
		return this.data.id;
	};
	ds.getHashId = function() {
		return this.get('hashId');
	};
	ds.hasQuestionTariffId = function() {
		return this.data.questionTariffId;
	};
	ds.hasPaymentMethodId = function() {
		return this.data.paymentMethodId;
	};
	ds.isLastUpdateOlderThan = function(seconds) {
		if (!this.data.lastUpdate) {
			return false;
		}
		var interval = Date.now() - this.data.lastUpdate;
		return (interval > seconds * 1000);
	};
	return ds;
});
